export const GET_LANGUAGE = "GET_LANGUAGE";
export const GET_LANGUAGE_SUCCEED = `${GET_LANGUAGE}_SUCCEED`;
export const GET_LANGUAGE_FAILED = `${GET_LANGUAGE}_FAILED`;

export const SAVE_CONFIGURATION = "SAVE_CONFIGURATION";

export const TOGGLE_CONFIGURATION_MODE = "TOGGLE_CONFIGURATION_MODE";

export const SET_KITCHEN_CONNECTION_STATE = "SET_KITCHEN_CONNECTION_STATE";



// WEBPACK FOOTER //
// ./src/redux/actions/types/configurationActionTypes.js